"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Modal, ModalBody, ModalFooter, ModalFooterButton, ModalHeader, ModalHeaderTitle, TextBody, TextDisplay, VisuallyHidden } from "@opensea/ui-kit";
import { Error } from "@opensea/ui-kit/icons";
import { bn } from "@opensea/utils";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { LISTING_MAX_DECIMALS } from "../../../constants";
export const ListingConfirmPriceModal = t0 => {
  const $ = _c(56);
  const {
    open,
    onNext,
    setIsOpen
  } = t0;
  const t = useTranslations("wallet.ListingConfirmPriceModal");
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "listings"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const listings = useWatch(t1);
  let T0;
  let T1;
  let T2;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== listings || $[3] !== onNext || $[4] !== setIsOpen || $[5] !== t) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const highSevPriceWarnings = listings.filter(_temp);
      const listingSymbol = listings[0].listingSymbol;
      if (highSevPriceWarnings.length === 0) {
        t7 = null;
        break bb0;
      }
      T2 = Modal;
      let t8;
      if ($[15] !== t) {
        t8 = t("titleVisuallyHidden");
        $[15] = t;
        $[16] = t8;
      } else {
        t8 = $[16];
      }
      if ($[17] !== t8) {
        t5 = <ModalHeader><VisuallyHidden><ModalHeaderTitle>{t8}</ModalHeaderTitle></VisuallyHidden></ModalHeader>;
        $[17] = t8;
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      let t9;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <FlexCenter className="rounded-full bg-error-1-transparent-1 p-3"><Error color="error-1" size={28} /></FlexCenter>;
        $[19] = t9;
      } else {
        t9 = $[19];
      }
      let t10;
      if ($[20] !== t) {
        t10 = t("title");
        $[20] = t;
        $[21] = t10;
      } else {
        t10 = $[21];
      }
      let t11;
      if ($[22] !== t10) {
        t11 = <TextDisplay size="sm">{t10}</TextDisplay>;
        $[22] = t10;
        $[23] = t11;
      } else {
        t11 = $[23];
      }
      const t12 = highSevPriceWarnings.length > 1 ? t("multipleBelowFloorWarning", {
        count: highSevPriceWarnings.length
      }) : t("singleBelowFloorWarning", {
        price: highSevPriceWarnings[0].price,
        symbol: listingSymbol,
        floorPrice: highSevPriceWarnings[0].floorPrice ? bn(highSevPriceWarnings[0].floorPrice).decimalPlaces(LISTING_MAX_DECIMALS).toString() : ""
      });
      let t13;
      if ($[24] !== t12) {
        t13 = <TextBody className="text-center text-secondary" size="md">{t12}</TextBody>;
        $[24] = t12;
        $[25] = t13;
      } else {
        t13 = $[25];
      }
      if ($[26] !== t11 || $[27] !== t13) {
        t6 = <ModalBody className="flex-col items-center gap-3">{t9}{t11}{t13}</ModalBody>;
        $[26] = t11;
        $[27] = t13;
        $[28] = t6;
      } else {
        t6 = $[28];
      }
      T1 = ModalFooter;
      let t14;
      if ($[29] !== setIsOpen) {
        t14 = () => {
          setIsOpen(false);
        };
        $[29] = setIsOpen;
        $[30] = t14;
      } else {
        t14 = $[30];
      }
      let t15;
      if ($[31] !== t) {
        t15 = t("cancelButton");
        $[31] = t;
        $[32] = t15;
      } else {
        t15 = $[32];
      }
      if ($[33] !== t14 || $[34] !== t15) {
        t4 = <ModalFooterButton onClick={t14} variant="secondary">{t15}</ModalFooterButton>;
        $[33] = t14;
        $[34] = t15;
        $[35] = t4;
      } else {
        t4 = $[35];
      }
      T0 = ModalFooterButton;
      if ($[36] !== onNext || $[37] !== setIsOpen) {
        t2 = () => {
          setIsOpen(false);
          onNext();
        };
        $[36] = onNext;
        $[37] = setIsOpen;
        $[38] = t2;
      } else {
        t2 = $[38];
      }
      t3 = t("confirmButton", {
        count: highSevPriceWarnings.length
      });
    }
    $[2] = listings;
    $[3] = onNext;
    $[4] = setIsOpen;
    $[5] = t;
    $[6] = T0;
    $[7] = T1;
    $[8] = T2;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    T0 = $[6];
    T1 = $[7];
    T2 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[39] !== T0 || $[40] !== t2 || $[41] !== t3) {
    t8 = <T0 onClick={t2}>{t3}</T0>;
    $[39] = T0;
    $[40] = t2;
    $[41] = t3;
    $[42] = t8;
  } else {
    t8 = $[42];
  }
  let t9;
  if ($[43] !== T1 || $[44] !== t4 || $[45] !== t8) {
    t9 = <T1>{t4}{t8}</T1>;
    $[43] = T1;
    $[44] = t4;
    $[45] = t8;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  let t10;
  if ($[47] !== t5 || $[48] !== t6 || $[49] !== t9) {
    t10 = <>{t5}{t6}{t9}</>;
    $[47] = t5;
    $[48] = t6;
    $[49] = t9;
    $[50] = t10;
  } else {
    t10 = $[50];
  }
  let t11;
  if ($[51] !== T2 || $[52] !== open || $[53] !== setIsOpen || $[54] !== t10) {
    t11 = <T2 content={t10} onOpenChange={setIsOpen} open={open} />;
    $[51] = T2;
    $[52] = open;
    $[53] = setIsOpen;
    $[54] = t10;
    $[55] = t11;
  } else {
    t11 = $[55];
  }
  return t11;
};
function _temp(listing) {
  return listing.shouldConfirmPrice;
}